var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('groups-query-list',{attrs:{"title":"Resultados das Consultas","subtitle":"Nesta tela você cria e verifica resultados de consultas.","create-route":{ name: 'Compliance-Legal-Person-Create' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }